export default __webpack_public_path__ + "assets/webgl/complete-25.99958415.jpg";